<template>
  <div class="bdWorkorder">
    <a-spin :spinning="loading">
      <div ref="searchRef">
        <SearchTools @searchList="searchList" :queryParams="queryParams" />
      </div>
      <div class="content">
        <a-table
          class="table"
          :pagination="tableData.pagination"
          :rowKey="(record, index) => index"
          :columns="columns"
          :data-source="tableData.list"
          @change="onChangePage"
          :scroll="{ x: '100%', y: `calc(100vh - ${sHeight}px )` }"
          :transformCellText="({ text }) => text ?? '--'"
        >
          <template #workOrderId="{ text, record }">
            <a-button type="link" @click="goDetails(record)">{{ text }}</a-button>
          </template>
        </a-table>
      </div>
      <PatientInfoDetails
        :showAllDialog="detailBar.showAllDialog"
        :currentInfo="detailBar.currentInfo"
        @handleCancel="handleCancel"
        :isBDOrder="true"
      />
    </a-spin>
  </div>
</template>
<script setup>
import SearchTools from './components/searchTools.vue'
import { columns, paginationConfig } from './config'
import { ref, onMounted, nextTick, reactive, computed } from 'vue'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { bdOrderList } from '@/api/Todo/bdWorkorder'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { useStore } from 'vuex'
import { defaultQuery } from './components/options'
import { cloneDeep } from 'lodash-es'
const searchRef = ref(null)
const loading = ref(false)
const detailBar = reactive({
  showAllDialog: false,
  currentInfo: {}
})
const sHeight = ref(318)
const store = useStore()
const { queryParams, initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.BD_WORK_ORDER_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultQuery,
  normalize: params => ({
    ...cloneDeep(defaultQuery),
    ...cloneDeep(params),
    orderCycle: Array.isArray(params?.orderCycle) ? params.orderCycle : []
  })
})
const tableData = reactive({
  pagination: paginationConfig,
  list: [],
  listQuery: cloneDeep(queryParams.value)
})

const searchList = params => {
  tableData.listQuery = updateCache({
    ...queryParams.value,
    ...(params || {}),
    curPage: 1,
    pageSize: paginationConfig.pageSize
  })
  getList()
}
// 改变当前页
const onChangePage = page => {
  tableData.listQuery = updateCache({
    ...queryParams.value,
    curPage: page.current,
    pageSize: page.pageSize
  })
  getList()
}
// 查询list
const getList = () => {
  loading.value = true
  const listQuery = tableData.listQuery
  const params = {
    ...listQuery,
    createdOnFrom: listQuery?.orderCycle[0] ?? '',
    createdOnTo: listQuery.orderCycle[1] ?? ''
  }
  delete params.orderCycle
  bdOrderList(params)
    .then(data => {
      const { totalCount, list = [], currPage, pageSize } = data
      tableData.list = list ?? []
      tableData.pagination.current = currPage
      tableData.pagination.pageSize = pageSize
      tableData.pagination.total = totalCount
      tableData.pagination.showTotal = () => `共${totalCount}条`
    })
    .finally(() => {
      loading.value = false
    })
}
// 动态获取搜索组件的高度
const getHeight = () => {
  nextTick(() => {
    sHeight.value = (searchRef?.value?.clientHeight || 318) + 200
  })
}
const handleCancel = () => {
  detailBar.showAllDialog = false
  detailBar.currentInfo = {}
}
//查看详情
const goDetails = record => {
  detailBar.showAllDialog = true
  detailBar.currentInfo = record
}
onMounted(() => {
  getHeight()
  tableData.listQuery = initFromCache()
  getList()
})
</script>
<style scoped lang="scss">
.bdWorkorder {
  position: relative;
  height: 100%;
  .content {
    padding: 20px;
  }
}
</style>
